<script>
    import FatalityRisk from './FatalityRisk.svelte';

    const stepData = [
        {
            "step":"1", 
            "title":"File", 
            "columns":5, 
            "rows":2, 
            "barriers":[
                "Limited number of advocates",
                "Outdated information",
                "Limited access to financial aid",
                "Housing is often short term",
                "Application is burdensome",
                "Lack of child care",
                "Time away from work",
                "Lack of legal aid",
                "Lack of paper trail for proof of abuse",
            ],
            "recommendations":[
                {"label":"Embed peer navigator model", "status":"incomplete"},
                {"label":"Post domestic violence informational fliers", "status":"complete"},
                {"label":"Centralize information", "status":"incomplete"},
                {"label":"Standardize training", "status":"incomplete"},
                {"label":"Co-locate social services", "status":"incomplete"},
                {"label":"Increase legal aid", "status":"incomplete"},
            ],
            "items": [
                // Split into learn about and decide
                {"label":"Learn how to request a restraining order", "column":1, "row":1, "path":"first", "risk":false},
                {"label":"Prepare and submit paperwork", "column":2, "row":1, "path":"normal", "risk":true, "position":"top"}, 
                {"label":"Filing accepted", "column":3, "row":1, "path":"continue", "risk":false},
                {"label":"Filing rejected", "column":3, "row":2, "path":"end", "risk":false, "connector":true},
                {"label":"Judge rules", "column":4, "row":1, "path":"normal", "risk":false},
                {"label":"Temporary restraining order granted/partially granted", "column":5, "row":1, "path":"continue", "risk":false},
                {"label":"Temporary restraining order denied", "column":5, "row":2, "path":"end", "risk":false, "connector":true}
            ]
        },
        {
            "step":"2", 
            "title":"Inform and Serve", 
            "columns":6, 
            "rows":2, 
            "barriers":[
                "May still have to interact with abusers",
                "Limited hours and locations to get forms",
                "Form copies are expensive",
                "Forms use legal terms and only in English",
                "Server is unable to locate respondent",
                "Respondent evades service",
                "Server files proof of service incorrectly",
                "Unaware that continuance is an option",
            ], 
            "recommendations":[
                {"label":"Extend emergency protective orders", "status":"incomplete"},
                {"label":"Embed peer navigator model", "status":"incomplete"},
                {"label":"Centralize information", "status":"incomplete"},
                {"label":"Standardize training", "status":"incomplete"},
                {"label":"Co-locate social services", "status":"incomplete"},
                {"label":"Provide 'rights' packet", "status":"complete"},
                {"label":"Provide copies of active protective orders", "status":"incomplete"},
                {"label":"Standardize notification of service", "status":"complete"},
            ],
            "items": [
                {"label":"Provide copies to employer, police, etc.", "column":1, "row":1, "risk":true, "position":"bottom"},
                {"label":"Choose server", "column":2, "row":1, "risk":false},
                {"label":"Prepare forms", "column":3, "row":1, "risk":false},
                {"label":"Service notice", "column":4, "row":1, "risk":true, "position":"top"},
                {"label":"Service failure", "column":4, "row":2, "risk":false, "connector":true},
                {"label":"File proof of service", "column":5, "row":1, "risk":false},
                {"label":"Proof of service filed incorrectly", "column":5, "row":2, "risk":false, "connector":true},
                {"label":"Service complete", "column":6, "row":1, "path":"continue", "risk":false},
                {"label":"Case dismissed", "column":6, "row":2, "path":"end", "risk":false, "connector":false},
            ]
        },
        {
            "step":"3", 
            "title":"Prepare", 
            "columns":3,
            "rows":2,
            "barriers":[
                "Unaware of how to prepare evidence",
                "Unaware of how to submit evidence",
                "May need to respond to motions or counter-petitions from abuser"
            ], 
            "recommendations":[
                {"label":"Increase legal aid", "status":"incomplete"},
            ],
            "items": [
                {"label":"Gather 'proof of abuse'", "column":1, "row":1, "path":"normal", "risk":false},
                {"label":"Prepare witnesses", "column":2, "row":1, "path":"normal", "risk":false},
                {"label":"Prepare statement", "column":3, "row":1, "path":"normal", "risk":false},
            ]
        },    
        {
            "step":"4", 
            "title":"Appear", 
            "columns":4, 
            "rows":2, 
            "barriers":[
                "Lack of child care",
                "Time away from work",
                "Unaware of how to present evidence",
                "No physical separation from abuser",
                "Testifying may be intimidating",
                "Variability in judicial experience",
                "Determinations are subjective",
            ], 
            "recommendations":[
                {"label":"Appoint clerks to courtrooms", "status":"incomplete"},
                {"label":"Reduce proximity to abuser", "status":"incomplete"},
                {"label":"Improve data tracking", "status":"incomplete"},
            ],
            "items": [
                {"label":"Check in at courtroom for hearing", "column":1, "row":1, "path":"normal", "risk":false},
                {"label":"Fail to appear at hearing", "column":1, "row":2, "path":"normal", "risk":false, "connector":true},
                {"label":"Present case", "column":2, "row":1, "path":"normal", "risk":false},
                {"label":"Case dismissed", "column":2, "row":2, "path":"end", "risk":false, "connector":false},
                {"label":"Judge rules", "column":3, "row":1, "path":"normal", "risk":true, "position":"top"},
                {"label":"Restraining order granted", "column":4, "row":1, "path":"continue", "risk":false},
                {"label":"Restraining order denied", "column":4, "row":2, "path":"end", "risk":false, "connector":true},
            ]
        }
        ]
</script>


<div id="journey-map-container">
    {#each stepData as step}
    <div class="step-container" id="step-{step.step}-{step.title.replace(/\s/g, '-').toLowerCase()}-map">
        <h2 class="step">Step {step.step}: {step.title}</h2>
        <div class="step-sub-container-outer" style="grid-template-columns: repeat({step.columns}, auto);">
            {#each step.items as item}
                <div class="step-sub-container-inner" style="grid-row:{item.row}; {item.span ? 'grid-column:'+item.column+' / '+item.span : 'grid-column:'+item.column}">
                    <div class="sub-step {item.path}">{item.label}</div>
                    {#if item.row == 2}
                        {#if item.connector == true}
                            <div class="left-connector row-{item.row}"></div>
                        {/if}
                    {/if}
                    {#if item.risk == true}<FatalityRisk position={item.position}></FatalityRisk>{/if}
                </div>
            {/each}
        </div>
    </div>
    {/each}
    {#each stepData as step}
        <div class="barriers-container">
            <div>
                <h3>Barriers</h3>
                <ul>
                    {#each step.barriers as barrier}
                    <li class="barrier">{barrier}</li>
                    {/each}
                </ul>
            </div>
            <div class="recommendations">
                <h3>OVP Recommendations</h3>
                <ul>
                    {#each step.recommendations as recommendation}
                    <li class="{recommendation.status}"><b class="{recommendation.status}"></b>{recommendation.label}</li>
                    {/each}
                </ul>
            </div>
        </div>
    {/each}
</div>
